import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { getMainMarketFromMarketType } from 'utils';

import { isEmptyCollection, isMarketTypeVisible, isSuspended, isVisible } from '@atlas/core';

import eventShape from 'common/PropTypes/eventShape';

import SimpleEmptyOutcomesRow from './SimpleEmptyOutcomesRow';
import SimpleOutcomeRowItem from './SimpleOutcomeRowItem';

const SimpleOutcomesRowWrapper = props => {
  const { event, marketTypes, suspended } = props;
  const mainMarketsToRender = marketTypes
    .filter(marketType => isMarketTypeVisible(marketType))
    .map(marketType => ({
      mainMarket: getMainMarketFromMarketType(marketType),
      marketType,
    }))
    .filter(({ mainMarket }) => !isEmptyCollection(mainMarket) && isVisible(mainMarket));

  if (isEmptyCollection(mainMarketsToRender)) {
    return {
      isEmpty: true,
      view: <SimpleEmptyOutcomesRow />,
    };
  }

  return {
    view: (
      <SimpleOutcomesRow
        event={event}
        hasOneActiveMarket={mainMarketsToRender.length === 1}
        mainMarketsToRender={mainMarketsToRender}
        suspended={suspended}
      />
    ),
  };
};

const SimpleOutcomesRow = props => {
  const { event, mainMarketsToRender, suspended } = props;
  const className = cx('event-market');

  return mainMarketsToRender.map(({ mainMarket, marketType }) => {
    const isMarketSuspended = suspended || isSuspended(mainMarket);

    return (
      <SimpleOutcomeRowItem
        className={className}
        event={event}
        key={mainMarket.id}
        mainMarket={mainMarket}
        marketType={marketType}
        suspended={isMarketSuspended}
      />
    );
  });
};

SimpleOutcomesRowWrapper.propTypes = {
  event: eventShape.isRequired,
  marketTypes: PropTypes.array.isRequired,
  suspended: PropTypes.bool,
};

SimpleOutcomesRow.propTypes = {
  event: eventShape.isRequired,
  mainMarketsToRender: PropTypes.array.isRequired,
  suspended: PropTypes.bool,
};

export default SimpleOutcomesRowWrapper;
